export default __webpack_public_path__ + "static/media/cancel.9452b00d.svg";